export enum ConditionExpressionType {
    Equal = "Equal",
    NotEqual = "NotEqual",
    ContainsString = "ContainsString",
    DoesNotContainString = "DoesNotContainString",
    Exists = "Exists",
    DoesNotExist = "DoesNotExist",
}
